<template>
  <div :class="getNoRemoteVideoClasses" :style="transparentColor">
    <RematchModal
      v-if="
        !loading &&
        started &&
        rematching &&
        sessionHasStarted &&
        user &&
        user._id &&
        sessionID &&
        !remoteParticipantData &&
        (past2Min || !hasPartner) &&
        !closedWhileRematching &&
        getTimeLeftToRematch && // is there still time left
        !sessionHasEnded
      "
      :UID="user._id"
      :SID="sessionID"
      :dateTimeMS="dateTimeMS"
      :timeLeftToRematch="timeLeftToRematch"
      :past2Min="past2Min"
      @rebootWithNewSessionID="rebootWithNewSessionID"
    />
    <div class="no-remote-content">
      <div
        v-if="!sessionHasEnded && !past10Min"
        class="no-remote-text"
        :class="remoteVideoConfig === 3 ? 'no-remote-text-small' : ''"
        :style="!remoteParticipantData ? 'margin-bottom: 20px;' : ''"
      >
        {{ hasPartner ? partnerComingText : noMatchText }}
      </div>
      <div v-if="sessionHasStarted && !past10Min && !sessionHasEnded" style="z-index: 99">
        <div
          v-if="hasPartner && !remoteParticipantData && past2Min === false"
          class="no-remote-text rematch-countdown"
          :class="remoteVideoConfig === 3 ? 'no-remote-text-small' : ''"
        >
          {{ `You can request a new partner in ${timeToRematch} minutes.` }}
        </div>
        <div
          v-if="(!hasPartner && !remoteParticipantData) || past2Min"
          class="no-remote-text rematch-countdown request-new-partner"
          :class="remoteVideoConfig === 3 ? 'no-remote-text-small' : ''"
          @click="openRematching"
        >
          Request a new partner
        </div>
      </div>

      <!-- 10 minute mark of the session has passed, disable rematch now-->
      <div v-if="past10Min && !sessionHasEnded">
        <div class="no-remote-text rematch-countdown rematch-is-up" :class="remoteVideoConfig === 3 ? 'no-remote-text-small' : ''">
          {{ `Time is up for requesting a rematch. You're more likely to get a new match now by booking a new session.` }}
        </div>
      </div>
      <FlyingCat v-if="hasPartner && !remoteParticipantData && remoteVideoConfig !== 3" />
      <LavaLamp v-else-if="!hasPartner && !remoteParticipantData && remoteVideoConfig !== 3" />
      <!--       <Waves v-else-if="!hasPartner && !remoteParticipantData && remoteVideoConfig !== 3" /> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getLayoutElementClasses } from "../SessionHelpers/layout";
import FlyingCat from "./FlyingCat";
import LavaLamp from "./LavaLamp";
import { transparentColor } from "../SessionHelpers/colors";
import RematchModal from "../../Session/SessionComponents/SessionRematch/RematchModal.vue";
/* import Waves from "./Waves.vue"; */

export default {
  name: "NoPartner",
  data() {
    return {
      noMatchText: "Still looking for a match...",
      partnerComingText: "Your partner is on their way!",

      timer: null,
      nowInMS: Date.now(),
      twoMinIntoSessionInMS: 0,
      tenMinIntoSessionInMS: 0,

      started: false,

      closedWhileRematching: false,
    };
  },
  components: {
    FlyingCat,
    LavaLamp,
    /*     Waves, */
    RematchModal,
  },
  props: {
    remoteParticipantData: Object,
    remoteParticipantScreenData: Object,
    themeCoreColor: String,
    themeBorderColor: String,
  },
  created() {
    const sessionStartTimeInMS = this.dateTimeMS;
    this.twoMinIntoSessionInMS = sessionStartTimeInMS + 2 * 60 * 1000;
    this.tenMinIntoSessionInMS = sessionStartTimeInMS + 10 * 60 * 1000;
    this.startTimer();
  },
  computed: {
    ...mapState({
      partnerMetadata: (state) => state.session.partnerMetadata,
      remoteVideoConfig: (state) => state.preferences.layoutConfig.remoteVideoConfig,
      dateTimeMS: (state) => state.session.dateTimeMS,

      user: (state) => state.auth.user,

      sessionID: (state) => state.session.sessionID,

      rematching: (state) => state.modals.rematching,

      firstRematch: (state) => state.rematching.firstRematch,

      loading: (state) => state.roomLoading.loading,
    }),
    hasPartner() {
      return this.hasSessionPartner();
    },
    transparentColor() {
      console.log(transparentColor());
      // return transparentColor();
      return "";
    },
    getNoRemoteVideoClasses() {
      const config = this.remoteVideoConfig;
      return getLayoutElementClasses(config, "noRemoteVideo");
    },
    timeToRematch() {
      return this.getTime();
    },
    past2Min() {
      if (this.nowInMS > this.twoMinIntoSessionInMS) {
        return true;
      }
      return false;
    },
    past10Min() {
      if (this.nowInMS > this.tenMinIntoSessionInMS) {
        return true;
      }
      return false;
    },
    sessionHasStarted() {
      if (this.nowInMS >= this.dateTimeMS) {
        return true;
      }
      return false;
    },
    sessionHasEnded() {
      const endTimeInMS = this.dateTimeMS + 50 * 60 * 1000;
      if (this.nowInMS >= endTimeInMS) {
        return true;
      }
      return false;
    },
    timeLeftToRematch() {
      return this.getTimeLeftToRematch();
    },
  },
  methods: {
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
      /* console.log("@STOP_TIMER"); */
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      /* console.log("@START_TIMER"); */
      this.calculateTime();
      this.timer = setInterval(this.calculateTime, 1000);
    },

    calculateTime() {
      this.nowInMS = Date.now();
      if (this.nowInMS >= this.dateTimeMS && !this.started) {
        this.started = true;
      }
      if ((this.nowInMS >= this.twoMinIntoSessionInMS && !this.firstRematch) || !this.hasSessionPartner) {
        this.$store.dispatch("rematching/setFirstRematchPopup", true);
        this.openRematching();
      }

      if (this.nowInMS > this.tenMinIntoSessionInMS) {
        this.$store.dispatch("modals/setModalState", {
          modal: "rematching",
          newState: false,
        });
      }
    },

    getTime() {
      return new Date(this.twoMinIntoSessionInMS - this.nowInMS).toISOString().substr(14, 5);
    },
    getTimeLeftToRematch() {
      let timeLeftInMS = new Date(this.tenMinIntoSessionInMS - this.nowInMS);
      if (timeLeftInMS < 0) {
        return false;
      } else {
        return timeLeftInMS.toISOString().substr(14, 5);
      }
    },
    rebootWithNewSessionID(SID) {
      this.closedWhileRematching = true;
      this.$emit("rebootWithNewSessionID", SID);
    },
    openRematching() {
      this.$store.dispatch("modals/setModalState", {
        modal: "rematching",
        newState: true,
      });
    },
    hasSessionPartner() {
      return this.partnerMetadata && this.partnerMetadata.ID ? true : false;
    },
  },
  beforeDestroy() {
    this.stopTimer();
  },
};
</script>

<style scoped>
.rematch-countdown {
  font-size: 23px !important;
  margin-bottom: 16px !important;
  background-color: white;
  padding: 6px 12px;
  border-radius: 360px;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(0 0 0 / 10%) 0px 3px 6px, rgb(245 245 245 / 20%) 0px 9px 24px;
}
.request-new-partner {
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(0 0 0 / 10%) 0px 3px 6px, rgb(129 129 129 / 20%) 0px 9px 24px !important;
  font-weight: 600 !important;
  cursor: pointer;
  z-index: 99;
}
.request-new-partner:hover {
  background-color: #ebebeb;
}
.rematch-is-up {
  width: 520px !important;
  border-radius: 12px !important;
  margin-top: -20px !important;
  font-size: 22px !important;
  margin-bottom: 50px !important;
  text-align: center !important;
  padding: 10px 12px !important;
  line-height: 26px !important;
}
</style>
